import React from "react";

import "./toolbar.css";

import DrawerToggleButton from "../SideDrawer/drawerToggleButton";

const toolbar = (props) => {
  let language = localStorage.getItem("language");

  if (props.messages_badge === "" || props.messages_badge === undefined)
    props.messages_badge = 0;

  let titulo = "";
  switch (props.label) {
    case "home":
      titulo = language === "en" ? "Home" : "Inicio";
      break;
    case "today":
      titulo = language === "en" ? "Today's Trips" : "Viajes de Hoy";
      break;
    case "yesterday":
      titulo = language === "en" ? "Yesterday's Trips" : "Viajes de Ayer";
      break;
    case "tomorrow":
      titulo = language === "en" ? "Tomorrow's Trips" : "Viajes de Mañana";
      break;
    case "messages":
      titulo = language === "en" ? "Messenger" : "Mensajería";
      break;
    case "settlements":
      titulo = language === "en" ? "Trip History" : "Historial de Viajes";
      break;
    case "settings":
      titulo = language === "en" ? "Settings" : "Configuraciones";
      break;
    case "profile":
      titulo = language === "en" ? "Profile" : "Perfil";
      break;
    case "assistance":
      titulo = language === "en" ? "Assistance" : "Asistencia";
      break;
    default:
      break;
  }

  return (
    <header className='toolbar'>
      <nav className='toolbar__navigation'>
        <div className='toolbar__toggle-button'>
          <DrawerToggleButton click={props.drawerClickHandler} />
        </div>
        <div className='toolbar__titulo'>
          {titulo}
        </div>
        <div className='toolbar__actions'>
          {props.messages_badge > 0 && (
            <button
              className='toolbar__icon-btn'
              onClick={props.messagesClickHandler}
              aria-label="Messages"
            >
              <i className='material-icons'>mail_outline</i>
              <span className='toolbar__badge'>{props.messages_badge}</span>
            </button>
          )}
          <button
            className='toolbar__icon-btn'
            onClick={() => window.location.reload(false)}
            aria-label="Refresh"
          >
            <i className='material-icons'>refresh</i>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default toolbar;
